import { action, observable } from 'mobx';
import { BaseEditViewStore } from 'core/stores';
import { PatientEditModalForm } from 'application/facility-order/forms';
import { PatientService } from "application/patient/services";
import _ from 'lodash';

class PatientEditModalViewStore extends BaseEditViewStore {
    @observable accessor patientInsuranceInfo = null;
    @observable accessor primaryInsurance = null;
    @observable accessor secondaryInsurance = null;
    @observable accessor oldPrimaryInsuranceDisplayed = false;         

    constructor(rootStore, componentProps) {
        const patientService = new PatientService(rootStore.application.baasic.apiClient);

        const patientKey = componentProps.modalParams.data.patientKey;

        super(rootStore, {
            name: 'patient-edit-modal',
            Form: PatientEditModalForm,
            id: patientKey,
            actions: () => {
                return {
                    get: async (id) => {
                        const response = await patientService.get(id);
                        _.extend(response.data, {
                            ssn: response.data.patientGeneralInfo && response.data.patientGeneralInfo.ssn,
                            height: response.data.patientClinicalInfo && response.data.patientClinicalInfo.height,
                            weight: response.data.patientClinicalInfo && response.data.patientClinicalInfo.weight,      
                        });
                        return response.data;
                    },
                    update: async (resource) => {
                        const response = await patientService.updatePatientDetails(resource);

                        return response;
                    }
                }
            },
            FormClass: PatientEditModalForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.refreshPatientData = componentProps.modalParams.data.refreshPatientData;
        this.validatePatientHeightAndWeight = componentProps.modalParams.data.validatePatientHeightAndWeight;

        this.patientKey = patientKey;
    }

    @action
    async setItem(item) {
        this.item = item;
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }

            await this.actions.update({
                patientBrightreeId: this.id,
                ...resource
            });

            this.form.setFieldsDisabled(false);

            this.modalParams.close();
            await this.refreshPatientData(this.patientKey);
            await this.validatePatientHeightAndWeight();

            await setTimeout(() => this.rootStore.notificationStore.success("TEMPLATES.PATIENT_DETAILS.EDIT"));
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }
}

export default PatientEditModalViewStore;
